var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-interface"
  }, [!_vm._id ? _c("v-classification", {
    attrs: {
      _groupCode: _vm._groupCode,
      contentData: _vm.contentData
    },
    on: {
      addOrderList: _vm.addOrderList
    }
  }) : _c("v-interface-details", {
    attrs: {
      _id: _vm._id,
      contentData: _vm.contentData
    },
    on: {
      addOrderList: _vm.addOrderList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };